namespace GeniuzPOS.Lookups {
    export namespace LookupSubCategory2Service {
        export const baseUrl = 'Lookups/LookupSubCategory2';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupSubCategory2Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Lookups/LookupSubCategory2/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>LookupSubCategory2Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
